/* OPEN CART */

function openCartDrawer(){

    const cartDrawer = document.querySelector('cart-drawer');

    // OPEN CART

    cartDrawer.classList.add('active');

    // CHECK CART ITEMS

    setTimeout(function() {

        const cartDrawerItems = document.querySelectorAll('.cart-drawer .cart-item');
        if(cartDrawerItems.length > 0){
            cartDrawer.classList.remove('is-empty');
        }else if(cartDrawerItems.length == 0){
            cartDrawer.classList.add('is-empty');
        }

    }, 1000);

}

function closeCartDrawer(){
    const cartDrawer = document.querySelector('cart-drawer');
    cartDrawer.classList.remove('active');
}

/* PRODUCT ATC */

let productsList = {'items':[]}

async function updateCartUI(){
    productsList['items'] = [];
    const res = await fetch('/?section_id=cart-drawer');
    const text = await res.text();
  
    const html = new DOMParser().parseFromString(text, 'text/html')
  
    const newBox = html.querySelector(".drawer").innerHTML;
    document.querySelector(".drawer").innerHTML = newBox;
}

async function addToCart(productsList) {
    try {
        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(productsList)
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.statusText}`);
        }

        const cart = await response.json();

        await updateCartUI();

    } catch (error) {
        console.error("Impossible d'ajouter le produit au panier", error);
    }
}

/* PRODUCT COMBINATIONS */

const productCombinations = document.querySelector('.product-combinations');

const productCombinationsProducts = productCombinations.querySelectorAll('.products .item');
const productCombinationsCheckbox = productCombinations.querySelectorAll('input[type="checkbox"]');
const productCombinationsBuyButton = productCombinations.querySelector('button');

const productCombinationsSelects = productCombinations.querySelectorAll('select');

const productCombinationsProductsPrices = document.querySelectorAll('.product-combinations .products .item .product-price');

function numberToEuro(number){
    const euroValue = (parseInt(number) / 100).toFixed(2).replace(".", ",") + "€";
    return euroValue;
}

function updateProductCombinationsChecked(){
    for(let i=0;i<productCombinationsProducts.length;i++){
        const checkox = productCombinationsProducts[i].querySelector('input[type="checkbox"]');
        if(checkox.checked == true){
            productCombinationsProducts[i].classList.add('checked');
        }else if(checkox.checked == false){
            productCombinationsProducts[i].classList.remove('checked');
        }
    }
}
updateProductCombinationsChecked();

function updateProductCombinationsPrices(){
    for(let i=0;i<productCombinationsProducts.length;i++){
        const productPriceItem = productCombinationsProducts[i].querySelector('.product-price');
        productPriceItem.innerHTML = `${numberToEuro(productPriceItem.dataset.price)}`;
    }
}
updateProductCombinationsPrices();

function updateProductCombinationsTotalPrice(){

    let totalPrice = 0;

    for(let i=0;i<productCombinationsProducts.length;i++){

        if(productCombinationsProducts[i].classList.contains('checked')){
            const productPrice = productCombinationsProducts[i].querySelector('.product-price').dataset.price;
            totalPrice = totalPrice+parseInt(productPrice);
        }

    }

    const productCombinationsTotalPrice = document.querySelector('.product-combinations #product-combinations__total-price');
    productCombinationsTotalPrice.innerHTML = `${numberToEuro(totalPrice)}`;

}
updateProductCombinationsTotalPrice();

productCombinationsCheckbox.forEach(checkbox => {
    checkbox.addEventListener('change', () => {
        updateProductCombinationsChecked();
        updateProductCombinationsTotalPrice();
    })  
});

productCombinationsBuyButton.addEventListener('click', () =>{
    
    let selectedProducts = {'items':[]}

    for(let i=0;i<productCombinationsProducts.length;i++){
        if(productCombinationsProducts[i].classList.contains('checked')){

            let productInfo = {id: productCombinationsProducts[i].id, quantity: 1}
            selectedProducts['items'].push(productInfo);

        }
    }

    addToCart(selectedProducts);

    openCartDrawer();
    
})

/* PRODUCT VARIANTS CHANGE */

productCombinationsSelects.forEach(select => {
    select.addEventListener('change', () => {
        itemParent = select.closest('.item');

        itemParent.id = select.value

        // GET OPTION PRICE
        const options = select.querySelectorAll('option');
        const optionPrice = options[select.options.selectedIndex].dataset.price;

        // UPSATE DISPLAY
        const ProductDataPrice = itemParent.querySelector('.product-price');
        ProductDataPrice.dataset.price = optionPrice;

        updateProductCombinationsPrices();
        updateProductCombinationsTotalPrice();
    })
})